var map = {
	"./10.avif": 1856,
	"./11.avif": 5903,
	"./12.avif": 7638,
	"./13.avif": 2309,
	"./14.avif": 2988,
	"./15.avif": 6491,
	"./16.avif": 3074,
	"./17.avif": 8801,
	"./18.avif": 88,
	"./19.avif": 8791,
	"./2.avif": 1137,
	"./20.avif": 171,
	"./3.avif": 2450,
	"./4.avif": 2431,
	"./5.avif": 1568,
	"./6.avif": 2005,
	"./7.avif": 5910,
	"./8.avif": 5139,
	"./9.avif": 2996,
	"./one.avif": 7747,
	"./sleep1.avif": 7455,
	"./three.avif": 5939,
	"./two.avif": 7433
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8775;